import { render } from "./BtnOptionPhonemicVowel.vue?vue&type=template&id=ddbca464&scoped=true"
import script from "./BtnOptionPhonemicVowel.vue?vue&type=script&lang=js"
export * from "./BtnOptionPhonemicVowel.vue?vue&type=script&lang=js"

import "@/css/components/btn-option-phonemic-vowel.css?vue&type=style&index=0&id=ddbca464&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbca464"]])

export default __exports__